"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GetGroupsRequest", {
    enumerable: true,
    get: function() {
        return GetGroupsRequest;
    }
});
const _zod = require("zod");
const GetGroupsRequest = _zod.z.object({
    hasEmployees: _zod.z.enum([
        "true",
        "false"
    ]).transform((val)=>val === "true").optional()
});
